var consts = {
    origin: __ORIGIN__
}

export default consts;